const margin = {
    name: "margin",
    path: "/margin",
    title: "margin",
    description: "Utilities for controlling the margin of elements.",
    value: {
        "margin": {
            "m-<number>": "calc(var(--1) * <number>)",
            "-m-<number>": "calc(var(--1) * -<number>)",
            "m-<fraction>": "calc(<fraction> * 100%)",
            "-m-<fraction>": "calc(-<fraction> * 100%)",
            "m-px": "1px",
            "-m-px": "-1px",    
            "m-[<value>]": "<value>",
        },
        "margin-inline": {
            "mx-<number>": "calc(var(--1) * <number>)",
            "-mx-<number>": "calc(var(--1) * -<number>)",
            "mx-<fraction>": "calc(<fraction> * 100%)",
            "-mx-<fraction>": "calc(-<fraction> * 100%)",
            "mx-px": "1px",
            "-mx-px": "-1px",
            "mx-auto": "auto",
            "mx-[<value>]": "<value>",
        },
        "margin-block": {
            "my-<number>": "calc(var(--1) * <number>)",
            "-my-<number>": "calc(var(--1) * -<number>)",
            "my-<fraction>": "calc(<fraction> * 100%)",
            "-my-<fraction>": "calc(-<fraction> * 100%)",
            "my-px": "1px",
            "-my-px": "-1px",
            "my-auto": "auto",
            "my-[<value>]": "<value>",
        },
        "margin-top": {
            "mt-<number>": "calc(var(--1) * <number>)",
            "-mt-<number>": "calc(var(--1) * -<number>)",
            "mt-<fraction>": "calc(<fraction> * 100%)",
            "-mt-<fraction>": "calc(-<fraction> * 100%)",
            "mt-px": "1px",
            "-mt-px": "-1px",
            "mt-[<value>]": "<value>",
        },
        "margin-right": {
            "mr-<number>": "calc(var(--1) * <number>)",
            "-mr-<number>": "calc(var(--1) * -<number>)",
            "mr-<fraction>": "calc(<fraction> * 100%)",
            "-mr-<fraction>": "calc(-<fraction> * 100%)",
            "mr-px": "1px",
            "-mr-px": "-1px",
            "mr-[<value>]": "<value>",
        },
        "margin-bottom": {
            "mb-<number>": "calc(var(--1) * <number>)",
            "-mb-<number>": "calc(var(--1) * -<number>)",
            "mb-<fraction>": "calc(<fraction> * 100%)",
            "-mb-<fraction>": "calc(-<fraction> * 100%)",
            "mb-px": "1px",
            "-mb-px": "-1px",
            "mb-[<value>]": "<value>",
        },
        "margin-left": {
            "ml-<number>": "calc(var(--1) * <number>)",
            "-ml-<number>": "calc(var(--1) * -<number>)",
            "ml-<fraction>": "calc(<fraction> * 100%)",
            "-ml-<fraction>": "calc(-<fraction> * 100%)",
            "ml-px": "1px",
            "-ml-px": "-1px",
            "ml-[<value>]": "<value>",
        },
        "": {
            "space-x-<number>":
`& > :not(:last-child) {
     margin-right: calc(var(--1) * <number>);
  }`,
            "-space-x-<number>":
`& > :not(:last-child) {
    margin-right: calc(var(--1) * -<number>);
  }`,
              "space-x-[<value>]":
`& > :not(:last-child) {
     margin-right: [<value>]);
  }`,

            "space-y-<number>":
`& > :not(:last-child) {
   margin-bottom: calc(var(--1) * <number>);
  }`,

            "-space-y-<number>":
`& > :not(:last-child) {
    margin-bottom: calc(var(--1) * -<number>);
  }`,
                "space-y-[<value>]":
`& > :not(:last-child) {
     margin-bottom: [<value>]);
  }`,
        },
    },

    exampleData: [
        {
            "example": {
                "code": `
div class="m-8 ...">m-8</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="mt-6 ...">mt-6</div>
<div class="mr-4 ...">mr-4</div>
<div class="mb-8 ...">mb-8</div>
<div class="ml-2 ...">ml-2</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="mx-8 ...">mx-8</div>
<div class="my-8 ...">my-8</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="h-16 w-36 bg-color-sky-400 opacity-20 ..."></div>
<div class="-mt-8 bg-sky-300 ...">-mt-8</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex space-x-4 space-y-8 ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex space-x-[10px] space-y-[20px] ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
    ],

    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">m-&lt;number&gt;</code>
                utilities like m-4 and m-8 to control the margin on all sides of an element:
            </p>
            <div class="flex justify-center font-mono text-sm leading-6 font-bold text-white">
                <div class="relative flow-root rounded-lg">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  m-8 text-color-white flex justify-center items-center rounded-lg p-4 size-20">m-8</div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">mt-&lt;number&gt; , mr-&lt;number&gt;, mb-&lt;number&gt;, ml-&lt;number&gt; </code>
                utilities like ml-2 and mt-6 to control the margin on one side of an element:
            </p>
            <div class="grid md:grid-columns-4 gap-6 items-center  font-mono text-sm leading-6 font-bold">
                <div class="relative flow-root rounded-lg w-fit">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  mt-6 text-color-white flex justify-center items-center rounded-lg p-4 size-20">mt-6</div>
                </div>
                
                <div class="relative flow-root rounded-lg w-fit">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  mr-4 text-color-white flex justify-center items-center rounded-lg p-4 size-20">mr-4</div>
                </div>

                <div class="relative flow-root rounded-lg w-fit">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  mb-8 text-color-white flex justify-center items-center rounded-lg p-4 size-20">mb-8</div>
                </div>

                <div class="relative flow-root rounded-lg w-fit">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  ml-2 text-color-white flex justify-center items-center rounded-lg p-4 size-20">ml-2</div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">mx-&lt;number&gt; , my-&lt;number&gt;</code>
                utilities like mx-4 and mx-8 to control the horizontal margin of an element:
            </p>
            <div class="grid md:grid-columns-2 gap-6 items-center justify-center  font-mono text-sm leading-6 font-bold">
                <div class="relative flow-root rounded-lg w-fit mx-auto">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  mx-8 text-color-white flex justify-center items-center rounded-lg p-4 size-20">mx-8</div>
                </div>
                
                <div class="relative flow-root rounded-lg w-fit mx-auto">
                    <div class="absolute inset-0 z-0">
                        <div class="h-full rounded-lg bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="relative bg-color-violet-500  my-8 text-color-white flex justify-center items-center rounded-lg p-4 size-20">my-8</div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">Using negative values</code>
                To use a negative margin value, prefix the class name with a dash to convert it to a negative value:
            </p>
            <div class=" w-fit mx-auto text-color-white">
                <div class="h-16 w-36 opacity-20 overflow-hidden rounded-md border border-color-sky-700/10 bg-color-sky-400/20"></div>
                <div class="relative -mt-8 flex items-center justify-center rounded-md bg-color-sky-500 p-4 w-fit mx-auto">-mt-8</div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">space-x-&lt;number&gt; , space-y-&lt;number&gt;</code>
                utilities like space-x-4 and space-y-8 to control the space between elements:
            </p>
            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid md:grid-columns-4 grid-columns-2 space-x-4 space-y-8 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                </div>
            </div>
            `
        },
                {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">space-x-[<value>]; , space-y-[<value>];</code>
                utilities like space-x-[10px] and space-y-[20px] to control the space between elements:
            </p>
            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid md:grid-columns-4 grid-columns-2 space-x-[10px] space-y-[20px] font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 mt-[15px] items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 mr-[25px] items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 mb-[30px] items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-14 flex-1 ml-[15px] items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                </div>
            </div>
            `
        }
    ]
};
export default margin;

<div class="bg-color-blue-300 sr-only mt-[15px] mr-[25px] mb-[30px] ml-[15px] space-x-4 space-y-8 space-x-[10px] space-y-[20px] m-8 mt-6 mr-4 mb-8 ml-2 mx-8 my-8 w-36 border-color-sky-700/10 bg-color-sky-400/20 -mt-8"></div>